import Navbar from "../components/Navbar/Navbar";
import "./layout.css";

const NormalLayout = (props) => {
  return (
    <>
      <Navbar isShadowActive />
      <div className="center-layout">{props.children}</div>
    </>
  );
};

export default NormalLayout;
